<template>
    <section id="hero" class="pt-24 pb-12 background-color-black bg-black text-white relative shadow-lg">
        <div
            class="absolute inset-0 pointer-events-none hidden lg:block"
            style="
                background: radial-gradient(
                    ellipse 30% 50% at 20% 48%, 
                    rgba(59,130,246,0.25) 0%, 
                    rgba(59,130,246,0.10) 50%, 
                    transparent 100%
                );
                mix-blend-mode: lighten;
            "
        ></div>
        <!-- md only: adjusted ellipse for better fit -->
        <div
            class="absolute inset-0 pointer-events-none hidden md:block lg:hidden"
            style="
                background: radial-gradient(
                    ellipse 45% 60% at 35% 50%, 
                    rgba(59,130,246,0.18) 0%, 
                    rgba(59,130,246,0.08) 50%, 
                    transparent 100%
                );
                mix-blend-mode: lighten;
            "
        ></div>
        <!-- sm and down: larger, more centered ellipse for coverage -->
        <div
            class="absolute inset-0 pointer-events-none md:hidden"
            style="
                     background: radial-gradient(
                ellipse 80% 20% at 30% 20%, 
                rgba(59,130,246,0.25) 0%, 
                rgba(59,130,246,0.10) 50%, 
                transparent 100%
            );
                mix-blend-mode: lighten;
            "
        ></div>

        <div class="absolute inset-0 "></div>
        <div class="container mx-auto px-6 flex flex-col md:flex-row items-center relative">

            <div class="w-full md:w-1/2 pr-4 sm:pr-10 py-14 sm:py-20 lg:p-18 al relative">
                <div class="relative flex items-center">
                    <img src="/img/laurels.svg" alt="Laurels"
                        class="absolute w-30 h-16 object-cover opacity-70 filter invert">
                    <div class="relative ml-7 text-center leading-tight text-xs">
                        <span class="text-gray-200 text-xs font-semibold">#1 <br>in realistic<br>images</span>
                    </div>
                </div>
                
                <h1 class="text-5xl text-gray-100 font-extrabold sm:text-5xl lg:text-[5.2rem] opacity-95 mt-4 relative py-2">
                    <span class="gradient-text">Business headshots</span>,<br> from selfies
                    <div class="absolute top-[-2rem] md:top-[-1rem] right-[3rem] md:right-[5rem] lg:right-[6rem] xl:right-[14rem] transform translate-x-1/2 -translate-y-1/2 rotate-12 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white text-sm font-bold px-2 py-1 shadow-lg text-center">
                        100% risk-free,<br>money-back guarantee
                    </div>
                </h1>
                <p class="text-gray-400 max-w-xl sm:mx-auto xl:mx-0 mt-8 text-lg sm:text-xl leading-relaxed pr-2 sm:pr-8">
                    <span
                        class="text-gray-400 max-w-xl sm:mx-auto xl:mx-0 mt-8 text-lg sm:text-xl leading-relaxed pr-1 sm:pr-8">
                        Make a great impression and stand out on LinkedIn, Teams or social media.
                        </span>
                </p>
                <div class="flex items-center gap-x-3 font-medium text-sm mt-6 py-4">
                    <template v-if="$page.props.auth && $page.props.auth.user">
                        <ShinyButton :href="route('flows.create')" class="h-12 px-6 flex items-center w-full sm:w-full lg:w-3/4">
                            Get your headshots
                        </ShinyButton>
                    </template>
                    <template v-else>
                        <ShinyButton v-if="canRegister" :href="route('quiz.index')" class="h-12 px-6 flex items-center w-full sm:w-full lg:w-3/4">
                            Get your headshots
                        </ShinyButton>
                    </template>
                    <!-- <button @click="scrollToAnchor('learnmore')"
                        class="h-12 px-2 border border-blue-800 text-blue-50 rounded-md hover:bg-blue-500 transition duration-50 flex items-center">
                        How it works
                    </button> -->
                </div>
            </div>

            <!-- masonry grid -->
            <div class="w-full md:w-1/2 mt-6 md:mt-0 py-2 md:py-16">
                <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6 ">
                    <div v-for="i in 6" :key="i"
                        class="rounded-2xl overflow-hidden shadow-md gallery-item relative bg-opacity-50 backdrop-filter backdrop-blur-lg border border-slate-700 group">
                        <img :src="`img/gallery/${i + 2}.jpg`" :alt="`Headshot ${i}`"
                            class="w-full h-[300px] object-cover transition-transform duration-300 group-hover:scale-105">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import ShinyButton from '@/Components/ShinyButton.vue';

defineProps({
    canRegister: {
        type: Boolean,
        default: false
    }
});

const scrollToAnchor = (anchorId) => {
    const element = document.getElementById(anchorId);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    }
};
</script>

<style scoped>
.gradient-text {
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}
</style>
